<template>
  <div>
    <div class="feedback-area">
      <div class="feedback">
        <transition name="fade" @enter="enterSuccessFeedback">
          <FeedbackSuccess
            v-if="showableSuccessFeedback"
            :message="successMessage"
          />
        </transition>
        <transition name="fade" @enter="enterErrorFeedback">
          <FeedbackError v-if="showableErrorFeedback" :message="errorMessage" />
        </transition>
      </div>
    </div>
    <section class="error-message-area white-area">
      <div class="white-area__content-area error-message__content-area">
        <img :src="mailConfirmedImage" alt="mail confirmed" />
        <h1 class="white-area__header error-message__header">
          URLが無効なようです...
        </h1>
        <p class="white-area__content">
          以下の理由が原因かもしれません。
        </p>
      </div>
      <ul class="error-cause__area">
        <li class="error-cause__list">
          <div class="buttons-multi error-cause__multi-button">
            <div class="btn-multi-block btn-multi-expand-block">
              <div class="btn-multi error-cause__button">
                有効期限が切れている場合
              </div>
              <div class="btn-multi-expand__contents">
                <div
                  class="caption btn-multi-expand__explanation error-cause__explanation"
                >
                  {{ resendMailExplanation }}
                  <div class="resend-mail__area">
                    <div
                      v-if="isNotAuthorizedError"
                      class="resend-mail__error-messages"
                    >
                      <p class="error-message">
                        お手数ですが
                        <a :href="baristaLoginUrl">
                          ログイン
                        </a>
                        をした状態で
                      </p>
                      <p class="error-message">
                        認証メールの再送をお願いします。
                      </p>
                    </div>
                    <a
                      class="text-link resend-mail__link"
                      @click.stop="onClickResendActivationMail"
                    >
                      {{ resendMailLinkText }}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
        <li class="error-cause__list">
          <div class="buttons-multi error-cause__multi-button">
            <div class="btn-multi-block btn-multi-expand-block">
              <div
                class="btn-multi error-cause__button btn-multi-expand--active"
              >
                認証メールを複数回送っている場合
              </div>
              <div class="btn-multi-expand__contents">
                <div
                  class="caption btn-multi-expand__explanation error-cause__explanation"
                >
                  最新のメールに記載されているURLより、改めてお試しください。
                </div>
              </div>
            </div>
          </div>
        </li>
        <li class="error-cause__list">
          <div class="buttons-multi error-cause__multi-button">
            <div class="btn-multi-block btn-multi-expand-block">
              <div
                class="btn-multi error-cause__button btn-multi-expand--active"
              >
                別のアカウントでログインしている場合
              </div>
              <div class="btn-multi-expand__contents">
                <div
                  class="caption btn-multi-expand__explanation error-cause__explanation"
                >
                  現在ログインしているアカウントを、マイページより一度ログアウトいただき、改めてお試しください。
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </section>
    <section class="contact__area white-area">
      <div class="contact__content">
        <p class="caption contact__message">
          上記で解決しない場合は、サポートへお問い合わせください。
        </p>
        <div class="contact__link-area">
          <a href="/contact" class="text-link contact__link">
            お問い合わせフォーム
          </a>
        </div>
      </div>
    </section>
    <section class="button-area">
      <a href="/" class="btn btn--primary back-to-top-button">
        gifteeトップへ戻る
      </a>
    </section>
  </div>
</template>
<script>
import Accounts from '../../../api/Accounts'
import FeedbackSuccess from '../../atoms/feedbacks/feedback-success'
import FeedbackError from '../../atoms/feedbacks/feedback-error'
import MailConfirmedImage from '../../../../../images/mail_conformed.svg'
import * as Sentry from '@sentry/browser'

export default {
  components: {
    FeedbackSuccess,
    FeedbackError
  },
  props: {
    isLoggedIn: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      showableSuccessFeedback: false,
      successMessage: '',
      showableErrorFeedback: false,
      errorMessage: '',
      mailConfirmedImage: '',
      isNotAuthorizedError: false,
      domainUrl: ''
    }
  },
  computed: {
    resendMailExplanation() {
      return this.isLoggedIn
        ? '発行後、24時間以上経過すると、URLが無効となります。認証メールを再送し、改めておためしください。'
        : '発行後、24時間以上経過すると、URLが無効となります。お手数ですがログインをした状態で認証メールの再送をお願いします。'
    },
    resendMailLinkText() {
      return this.isLoggedIn ? '認証メールを再送する' : 'ログインする'
    },
    baristaLoginUrl() {
      return `/barista/sessions/new?redirect_path=${this.domainUrl}/accounts/activation_error`
    }
  },
  mounted() {
    this.mailConfirmedImage = MailConfirmedImage
    this.domainUrl = `${location.protocol}//${location.host}`
  },
  methods: {
    beforeEnter(el) {
      el.style.height = '0'
    },
    enter(el) {
      el.style.height = el.scrollHeight + 'px'
    },
    beforeLeave(el) {
      el.style.height = el.scrollHeight + 'px'
    },
    leave(el) {
      el.style.height = '0'
    },
    enterSuccessFeedback() {
      setTimeout(() => {
        this.showableSuccessFeedback = false
      }, 3000)
    },
    enterErrorFeedback() {
      setTimeout(() => {
        this.showableErrorFeedback = false
      }, 3000)
    },
    onClickResendActivationMail() {
      if (this.isLoggedIn) {
        this.sendActivationMail()
        return
      }

      location.href = this.baristaLoginUrl
    },
    async sendActivationMail() {
      try {
        await Accounts.sendActivationMail()
        this.showableSuccessFeedback = true
        this.successMessage = '認証メールを送信しました'
      } catch (error) {
        if (error.response && error.response.status === 404) {
          this.successMessage =
            'メール認証がすでに完了しています。トップページへお戻りください。'
          this.showableSuccessFeedback = true
          // NOTE: ここだけ success フィードバックなので return している
          return
        }

        if (error.response && error.response.status === 401) {
          this.errorMessage = '送信できませんでした'
          this.isNotAuthorizedError = true
        } else {
          this.errorMessage =
            'システムエラーが発生しました。しばらく経ってから再度アクセスしてください。'
          Sentry.captureException(error)
        }
        this.showableErrorFeedback = true
      }
    }
  }
}
</script>
